import { setupWorker } from "msw";
import { handlers } from "./handlers";

// Service worker cannot be instantiated in Node, which Jest requires
export const worker = !isNode() ? setupWorker(...handlers) : undefined;

export function isNode(): boolean {
  return (
    typeof process === "object" &&
    typeof process.versions === "object" &&
    typeof process.versions.node !== "undefined"
  );
}
